<div class="loader-bg col-12" *ngIf="showLoader">
  <span class="loader"><span class="loader-inner"></span></span>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/shared/loader/loadar.component.html